import _ from "lodash";
import { ActionTypes } from "../constants/actionTypes";
import { apiService } from "../services/apiService";
import { updateLoader } from "./loaderAction";

export const groupsFetch = (toursData) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.GROUPS_FETCH,
      payload: toursData,
    });
  };
};

export const resetGroups = () => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_GROUPS_FETCH,
    });
  };
};

export const pageGroupsFetch = (authParams, filter, navigate, handleError) => {
  return async (dispatch) => {
    const response = await apiService.getAllGroups(authParams, filter);

    if (response.status !== 200) {
      if (response.status === 401) return navigate("/unauthorized");
      return handleError(response.data);
    }

    const toursResponse = response.data;
    const payload = {
      data: toursResponse?.groups,
      total: toursResponse?.paginationInfo?.total,
      currentPageNumber: toursResponse?.paginationInfo?.currentPage,
      totalPageNumber: toursResponse?.paginationInfo?.numberOfPages,
    };

    dispatch(groupsFetch(payload));
    dispatch(updateLoader({ reconLoading: false }));
  };
};

export const getAllGroupsDetails = (
  authParams,
  filter,
  navigate,
  handleError
) => {
  return async (dispatch) => {
    const response = await apiService.getAllGroups(authParams, filter);
    const groups = [];
    groups.push(...(response?.data?.groups || []));

    const totalPages = response?.data?.paginationInfo?.numberOfPages || 1;
    const requests = [];

    for (let i = 2; i <= totalPages; i++) {
      requests.push({
        authParams: authParams,
        filter: { ...filter, page: i },
      });
    }

    const requestsChunk = _.chunk(requests, 5);
    for (const chunk of requestsChunk) {
      const resolvedRequests = await Promise.all(
        chunk.map((r) => apiService.getAllGroups(r.authParams, r.filter))
      );
      for (const item of resolvedRequests) {
        if (item?.status === 200) {
          groups.push(...(item?.data?.groups || []));
        }
        if (item.status !== 200) {
          if (item.status === 401) return navigate("/unauthorized");
          return handleError(item.data);
        }
      }
    }

    dispatch({
      type: ActionTypes.ALL_GROUPS_FETCH,
      payload: {
        data: groups,
      },
    });
  };
};
